module.exports = __webpack_public_path__ + "static/media/eslovvapen.893c29e6.png";